import { useEffect, useState } from "react";
import { Grid, Icon, IconButton, Typography } from "@mui/material";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { typePhoneOptions } from "constants/CodConstants";
import { useHookFormMask } from "use-mask-input";

const CustomerPhonesForm = ({ formPhones = [], setFormPhones, setData = [] }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: { number: "", type: "CELULAR" },
  });

  const registerWithMask = useHookFormMask(register);

  const type = watch("type");

  const handleInputChange = (index, field, value) => {
    const updatedPhones = [...formPhones];
    updatedPhones[index][field] = value;
    setData(updatedPhones);
  };

  const addInputsFormPhones = () => {
    setFormPhones([...formPhones, { number: "", type: "CELULAR" }]);
  };

  const removeInputFormPhone = (index) => {
    const updatedPhones = formPhones.filter((_, i) => i !== index);
    setFormPhones(updatedPhones);
    setData(updatedPhones);
  };

  return (
    <>
      <Grid container spacing={2}>
        {formPhones.length == 0 ? (
          <Grid item xs={12}>
            <Link>
              <Typography
                onClick={addInputsFormPhones}
                variant="h6"
                component="h2"
                sx={{ color: "#000", fontWeight: "bold", marginBottom: 1 }}
              >
                {`Clique aqui para adicionar o numero de contato`}
              </Typography>
            </Link>
          </Grid>
        ) : (
          formPhones.map((phone, index) => (
            <>
              <Grid item xs={8}>
                <MDInput
                  variant="outlined"
                  fullWidth
                  id={`number-${index}`}
                  label="Telefone"
                  name="number"
                  value={phone.number}
                  onChange={(e) => handleInputChange(index, "number", e.target.value)}
                  // {...registerWithMask("number", "99 [9]9999-9999")}
                />
              </Grid>
              <Grid item xs={2}>
                <MDSelect
                  select
                  required
                  variant="outlined"
                  fullWidth
                  id={`type-${index}`}
                  label="Tipo de Telefone"
                  placeholder="Tipo de Telefone"
                  name="type"
                  value={phone.type}
                  options={typePhoneOptions}
                  onChange={(e) => handleInputChange(index, "type", e.target.value)}
                />
              </Grid>
              <Grid item xs={2} key={index}>
                <IconButton
                  sx={{ color: "#000", fontWeight: "bold", marginBottom: 1 }}
                  onClick={() => removeInputFormPhone(index)}
                >
                  <Icon>cancel</Icon>
                </IconButton>
              </Grid>
            </>
          ))
        )}
        {formPhones.length != 0 ? (
          <Link>
            <Typography
              onClick={addInputsFormPhones}
              variant="h6"
              component="h2"
              sx={{ p: 2, color: "#000", fontWeight: "bold", marginBottom: 1 }}
            >
              {`Adicionar mais numero de contato?`}
            </Typography>
          </Link>
        ) : null}
      </Grid>
    </>
  );
};

export default CustomerPhonesForm;

CustomerPhonesForm.propTypes = {
  setData: PropTypes.array,
  formPhones: PropTypes.array,
  setFormPhones: PropTypes.array,
};
